import { gql } from '@apollo/client';

export const HIVE_ACCOUNT_CREATABLE = gql`
  query hiveAccountCreatable {
    hiveAccountCreatable
  }
`;

export const CREATE_HIVE_ACCOUNT = gql`
  mutation createHiveAccount(
    $username: String!
    $posting: String!
    $active: String!
    $owner: String!
    $memo: String!
  ) {
    createHiveAccount(
      username: $username
      posting: $posting
      active: $active
      owner: $owner
      memo: $memo
    ) {
      success
      message
    }
  }
`;
